module.exports = __webpack_public_path__ + "static/media/users.d5dffb57.svg";